import GlobeArrow from './GlobeArrow'

export default GlobeArrow
// eslint-disable-next-line import/export
export * from './GlobeArrow'
